import { Location } from './location';

export class Stop {
  id: number;
  lumperFee: number;
  location: Location = new Location();
}
